/*
 * Fellheimat - Groessenrechner (Rasse + Alter)
 *
 * ABLAUF: Rasse -> Alter -> (Gewicht nur wenn noetig) -> Ergebnis.
 * Rasse und Alter sind Pflicht, das Gewicht ist freiwillig. Hals- und
 * Brustumfang wurden am 31.08.2026 aus dem Rechner entfernt; die Werte
 * stehen weiter im Bild der Groessentabelle, das ueber die Fusszeile auf
 * jedem Schritt erreichbar bleibt.
 *
 * RECHENWEG
 * 1. Die Rasse liefert die Endgewichtsspanne erwachsener Hunde. Die Spanne
 *    ist bewusst breit (Huendin-Minimum bis Rueden-Maximum).
 * 2. Das Alter liefert einen Prozentfaktor auf diese Spanne. Die Kurve
 *    haengt nur an der Groessenklasse, die aus dem Mittelwert der
 *    Endspanne abgeleitet wird - kleine Rassen sind mit rund 10 Monaten
 *    ausgewachsen, riesige erst mit 24.
 * 3. Empfohlen wird die Groesse, in die der MITTELWERT der geschaetzten
 *    Spanne faellt, also der typische Hund. Nicht der Spannenrand: sonst
 *    laege bei 40 % aller Rassen ein Grenzfall vor und der Rechner muesste
 *    fast immer nachfragen.
 * 4. Zusaetzlich wird gemessen, welcher ANTEIL der Spanne in dieser Groesse
 *    liegt. Ab CONFIDENCE gilt die Empfehlung als sicher. Darunter wird die
 *    Gewichtsfrage angeboten - sie ist damit kein Deko-Schritt, sondern
 *    erscheint genau dann, wenn sie das Ergebnis aendern kann.
 *
 * DAS ERGEBNIS IST IMMER EINDEUTIG (Ansage des Betreibers, 31.08.2026).
 * Es gibt genau eine Groesse und keinen Zusatz, der daran zweifelt: kein
 * "koennte auch L sein", kein "miss lieber nach", kein Welpen-Ausblick auf
 * die naechste Groesse. Auch unter CONFIDENCE und auch wenn das Gewicht
 * uebersprungen wurde, steht die wahrscheinlichste Groesse da - sonst
 * nichts. Wer es genauer will, hat die Groessentabelle in der Fusszeile.
 * Die entfernten Bausteine sind in FELLHEIMAT-HANDOVER.md, Abschnitt 13
 * beschrieben, falls sie je zurueck sollen.
 *
 * WICHTIG: Ein eingetragenes Gewicht schlaegt jede Schaetzung und laeuft
 * durch dieselbe candidate()-Funktion wie vor dem Umbau. Die Grenzwerte
 * sind unveraendert: 7,5 kg -> S, 7,6 kg -> M, 22,5 kg -> L.
 *
 * Bei Mehrdeutigkeit wird die WAHRSCHEINLICHSTE Groesse empfohlen, nicht
 * die groessere. Die alte Regel "im Zweifel die groessere" galt fuer drei
 * gemessene Maasse, die alle passen mussten. Eine Rassenschaetzung ist
 * etwas anderes: ein zu grosses Geschirr an einem 15-kg-Hund ist ein
 * Sicherheitsproblem, gegen das dieses Produkt ausdruecklich wirbt.
 *
 * Die Groesse wird gesetzt, indem der passende Radio-Input im
 * <variant-picker> auf checked gesetzt und ein change-Event ausgeloest
 * wird. Horizons VariantPicker haengt genau daran. Ein click() ginge durch
 * das umschliessende <label> doppelt.
 */
(function () {
  if (window.fhSizeCalcReady) return;
  window.fhSizeCalcReady = true;

  var TTL = 30 * 24 * 60 * 60 * 1000;
  var MAX_HITS = 6;

  function num(raw) {
    if (raw === null || raw === undefined) return NaN;
    var s = String(raw).trim().replace(',', '.');
    if (!s) return NaN;
    var v = parseFloat(s);
    return isFinite(v) ? v : NaN;
  }

  function fmt(v) {
    return String(Math.round(v * 10) / 10).replace('.', ',');
  }

  // Umlaute und Akzente raus, damit "schaferhund" und "Schäferhund" treffen.
  function norm(s) {
    s = String(s || '').toLowerCase();
    s = s.replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss');
    if (s.normalize) s = s.normalize('NFD').replace(/[̀-ͯ]/g, '');
    return s.replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function json(root, sel, fallback) {
    var el = root.querySelector(sel);
    if (!el) return fallback;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return fallback;
    }
  }

  function sizesOf(root) {
    if (root.fhSizes) return root.fhSizes;
    var raw = json(root, '[data-fh-sc-data]', []) || [];
    root.fhSizes = raw.map(function (s) {
      return { label: String(s.label).trim(), weight: [num(s.weight[0]), num(s.weight[1])] };
    });
    return root.fhSizes;
  }

  function configOf(root) {
    if (root.fhConfig) return root.fhConfig;
    var c = json(root, '[data-fh-sc-config]', {}) || {};
    c.curves = c.curves || {};
    c.mix = c.mix || {};
    c.confidence = isFinite(num(c.confidence)) ? num(c.confidence) : 0.65;
    root.fhConfig = c;
    return c;
  }

  /* ---------------------------------------------------------------- Daten */

  // Groessenklasse aus dem Mittelwert der Endgewichtsspanne. Steht bewusst
  // nicht in der Rassendatei - ein Feld weniger, das falsch sein kann.
  function classOf(w) {
    var m = (w[0] + w[1]) / 2;
    if (m < 10) return 'klein';
    if (m < 25) return 'mittel';
    if (m < 45) return 'gross';
    return 'riesig';
  }

  // "2:15, 3:27, 4:38" -> [[2,0.15],[3,0.27],[4,0.38]]
  function parseCurve(raw) {
    var out = [];
    String(raw || '')
      .split(',')
      .forEach(function (part) {
        var bits = part.split(':');
        if (bits.length !== 2) return;
        var m = num(bits[0]);
        var p = num(bits[1]);
        if (isFinite(m) && isFinite(p)) out.push([m, p / 100]);
      });
    out.sort(function (a, b) {
      return a[0] - b[0];
    });
    return out;
  }

  function curveOf(root, cls) {
    var cfg = configOf(root);
    cfg.parsed = cfg.parsed || {};
    if (!cfg.parsed[cls]) cfg.parsed[cls] = parseCurve(cfg.curves[cls]);
    return cfg.parsed[cls];
  }

  // Anteil vom Endgewicht in diesem Alter. Linear interpoliert.
  function growth(root, cls, months) {
    var pts = curveOf(root, cls);
    if (!pts.length) return 1;
    if (months <= pts[0][0]) return pts[0][1];
    if (months >= pts[pts.length - 1][0]) return 1;
    for (var i = 1; i < pts.length; i++) {
      if (months <= pts[i][0]) {
        var t = (months - pts[i - 1][0]) / (pts[i][0] - pts[i - 1][0]);
        return pts[i - 1][1] + (pts[i][1] - pts[i - 1][1]) * t;
      }
    }
    return 1;
  }

  /* -------------------------------------------------------------- Rechnen */

  // Kleinste Groesse, die den Wert aufnimmt. Unveraendert seit 19.08.
  function candidate(sizes, value) {
    var n = sizes.length;
    if (!n || !isFinite(value)) return null;

    var lastMax = sizes[n - 1].weight[1];
    if (isFinite(lastMax) && value > lastMax) return { idx: n - 1, state: 'above' };

    var firstMin = sizes[0].weight[0];
    if (isFinite(firstMin) && value < firstMin) return { idx: 0, state: 'below' };

    for (var i = 0; i < n; i++) {
      var r = sizes[i].weight;
      if (isFinite(r[0]) && isFinite(r[1]) && value >= r[0] && value <= r[1]) {
        return { idx: i, state: 'fit' };
      }
    }
    for (var j = 0; j < n; j++) {
      if (isFinite(sizes[j].weight[0]) && value < sizes[j].weight[0]) return { idx: j, state: 'fit' };
    }
    return { idx: n - 1, state: 'fit' };
  }

  // Wie viel Prozent der geschaetzten Spanne faellt in welche Groesse?
  function shares(sizes, range) {
    var lo = range[0];
    var hi = range[1];
    var width = hi - lo;
    var out = [];
    var sum = 0;

    for (var i = 0; i < sizes.length; i++) {
      var a = sizes[i].weight[0];
      var b = sizes[i].weight[1];
      // Die Randgroessen fangen alles ausserhalb der Tabelle mit ein.
      if (i === 0) a = Math.min(a, lo);
      if (i === sizes.length - 1) b = Math.max(b, hi);
      var v;
      if (width <= 0) v = lo >= a && lo <= b ? 1 : 0;
      else v = Math.max(0, Math.min(hi, b) - Math.max(lo, a)) / width;
      out.push(v);
      sum += v;
    }
    if (!sum) return out;
    return out.map(function (v) {
      return v / sum;
    });
  }

  function estimate(root) {
    var vals = root.fhVals || {};
    var breed = vals.breed;
    if (!breed) return null;

    var adult = breed.w;
    var cls = classOf(adult);
    var months = vals.ageKind === 'puppy' ? vals.months : null;
    var f = months === null || !isFinite(months) ? 1 : growth(root, cls, months);
    return { cls: cls, adult: adult, months: months, range: [adult[0] * f, adult[1] * f] };
  }

  function compute(root) {
    var sizes = sizesOf(root);
    var cfg = configOf(root);
    var vals = root.fhVals || {};
    var est = estimate(root);
    if (!sizes.length || !est) return { ok: false };

    var out = { ok: true, est: est, breed: vals.breed, ageKind: vals.ageKind, months: est.months };
    var weight = vals.weight;

    if (isFinite(weight)) {
      var c = candidate(sizes, weight);
      out.idx = c.idx;
      out.basis = 'weight';
      out.weight = weight;
      out.certain = true;
    } else {
      var mid = (est.range[0] + est.range[1]) / 2;
      var idx = candidate(sizes, mid).idx;
      var p = shares(sizes, est.range);

      out.idx = idx;
      out.basis = 'estimate';
      out.confidence = p[idx];
      // certain steuert nur noch, ob die Gewichtsfrage angeboten wird.
      // Im Ergebnis selbst taucht die Unsicherheit nicht mehr auf.
      out.certain = p[idx] >= cfg.confidence;
    }

    out.size = sizes[out.idx].label;
    return out;
  }

  /* ----------------------------------------------------------- Rassenliste */

  function loadBreeds(root) {
    if (root.fhBreedsPromise) return root.fhBreedsPromise;
    var url = root.dataset.breedsUrl;
    root.fhBreedsPromise = fetch(url)
      .then(function (r) {
        return r.json();
      })
      .then(function (d) {
        var list = (d && d.breeds) || [];
        root.fhBreeds = list.map(function (b) {
          var hay = [norm(b.n)].concat((b.a || []).map(norm));
          return { n: b.n, w: b.w, hay: hay.join(' ') };
        });
        return root.fhBreeds;
      })
      .catch(function () {
        root.fhBreeds = [];
        return root.fhBreeds;
      });
    return root.fhBreedsPromise;
  }

  function search(root, term) {
    var list = root.fhBreeds || [];
    var q = norm(term);
    if (!q) return [];
    var starts = [];
    var contains = [];
    for (var i = 0; i < list.length; i++) {
      var pos = list[i].hay.indexOf(q);
      if (pos === 0 || (pos > 0 && list[i].hay.charAt(pos - 1) === ' ')) starts.push(list[i]);
      else if (pos > 0) contains.push(list[i]);
      if (starts.length >= MAX_HITS) break;
    }
    return starts.concat(contains).slice(0, MAX_HITS);
  }

  function renderHits(root, hits) {
    var box = root.querySelector('[data-fh-sc-breed-list]');
    var empty = root.querySelector('[data-fh-sc-breed-empty]');
    if (!box) return;
    box.innerHTML = '';

    for (var i = 0; i < hits.length; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'fh-sizecalc__hit';
      b.setAttribute('data-fh-sc-pick', hits[i].n);
      b.textContent = hits[i].n;
      box.appendChild(b);
    }
    box.hidden = !hits.length;

    var term = (root.querySelector('[data-fh-sc-breed-search]') || {}).value || '';
    if (empty) empty.hidden = !(norm(term) && !hits.length);
  }

  // Erst exakt, dann normalisiert. Die Schnellwahl-Chips kommen aus einem
  // Textfeld im Theme-Editor - ein fehlender Umlaut darf den Knopf nicht
  // wirkungslos machen.
  function breedByName(root, name) {
    var list = root.fhBreeds || [];
    var i;
    for (i = 0; i < list.length; i++) {
      if (list[i].n === name) return list[i];
    }
    var q = norm(name);
    for (i = 0; i < list.length; i++) {
      if (norm(list[i].n) === q) return list[i];
    }
    return null;
  }

  /* ------------------------------------------------------------- Anzeigen */

  // Die Gewichtsfrage laeuft nur mit, wenn sie das Ergebnis aendern kann.
  function stepsOf(root) {
    var s = ['breed', 'age'];
    if (root.fhNeedWeight) s.push('weight');
    return s;
  }

  function show(root, step) {
    var steps = root.querySelectorAll('[data-fh-sc-step]');
    for (var i = 0; i < steps.length; i++) {
      steps[i].hidden = steps[i].getAttribute('data-fh-sc-step') !== step;
    }
    root.dataset.step = step;
    root.classList.toggle('is-table', step === 'table');

    // Die Fusszeile fuehrt zur Tabelle - dort selbst waere sie sinnlos.
    var foot = root.querySelector('[data-fh-sc-foot]');
    if (foot) foot.hidden = step === 'table';

    var order = stepsOf(root);
    var pos = order.indexOf(step);
    var pct = pos === -1 ? 100 : ((pos + 1) / (order.length + 1)) * 100;
    var fill = root.querySelector('[data-fh-sc-progress-fill]');
    if (fill) fill.style.width = pct + '%';

    var active = root.querySelector('[data-fh-sc-step="' + step + '"]');
    if (!active) return;

    // Schrittzaehler mitziehen, die Zahl haengt am gewaehlten Weg.
    var kicker = active.querySelector('[data-fh-sc-kicker]');
    if (kicker && pos !== -1) {
      kicker.textContent = (root.dataset.stepTemplate || 'Schritt [n] von [max]')
        .replace('[n]', pos + 1)
        .replace('[max]', order.length);
    }

    if (step === 'breed') {
      var inp = root.querySelector('[data-fh-sc-breed-search]');
      // Auf dem Handy nicht automatisch fokussieren, sonst schiebt die
      // Tastatur die Chips sofort aus dem Bild.
      if (inp && window.matchMedia && window.matchMedia('(min-width: 750px)').matches) {
        try {
          inp.focus({ preventScroll: true });
        } catch (e) {}
      }
    }
    if (step === 'weight') {
      var w = root.querySelector('[data-fh-sc-input="weight"]');
      if (w) {
        try {
          w.focus({ preventScroll: true });
        } catch (e) {}
      }
    }

    var body = root.querySelector('.fh-sizecalc__body');
    if (body) body.scrollTop = 0;
  }

  function fill(root, sel, text, hideWhenEmpty) {
    var el = root.querySelector(sel);
    if (!el) return;
    el.textContent = text || '';
    if (hideWhenEmpty) el.hidden = !text;
  }

  function tpl(root, key, fallback, map) {
    var s = root.dataset[key] || fallback || '';
    for (var k in map) {
      if (Object.prototype.hasOwnProperty.call(map, k)) s = s.split(k).join(map[k]);
    }
    return s;
  }

  function ageLabel(root, res) {
    if (res.ageKind === 'puppy') {
      return tpl(root, 'ageMonthsLabel', '[n] Monate', { '[n]': fmt(res.months) });
    }
    if (res.ageKind === 'senior') return root.dataset.ageSeniorLabel || 'Senior';
    return root.dataset.ageAdultLabel || 'Ausgewachsen';
  }

  function finish(root) {
    var res = compute(root);
    if (!res.ok) {
      show(root, 'none');
      return;
    }
    root.fhResult = res;

    var label = res.size;
    var lo = fmt(res.est.range[0]);
    var hi = fmt(res.est.range[1]);

    fill(root, '[data-fh-sc-size]', label);

    // Begruendung: woher kommt die Empfehlung?
    var reason;
    if (res.basis === 'weight') {
      reason = tpl(root, 'reasonWeight', 'Ausschlaggebend ist das Gewicht ([kg] kg).', {
        '[kg]': fmt(res.weight)
      });
    } else if (res.months !== null && isFinite(res.months)) {
      reason = tpl(root, 'reasonPuppy', '[rasse] wiegt mit [n] Monaten typisch [von] bis [bis] kg.', {
        '[rasse]': res.breed.n,
        '[n]': fmt(res.months),
        '[von]': lo,
        '[bis]': hi
      });
    } else {
      // Ohne Artikel, sonst kollidiert das Genus mit dem Rassennamen.
      reason = tpl(root, 'reasonAdult', '[rasse] wiegt ausgewachsen typisch [von] bis [bis] kg.', {
        '[rasse]': res.breed.n,
        '[von]': lo,
        '[bis]': hi
      });
    }
    fill(root, '[data-fh-sc-reason]', reason);

    var recap = [res.breed.n, ageLabel(root, res)];
    if (isFinite(res.weight)) recap.push(fmt(res.weight) + ' kg');
    fill(root, '[data-fh-sc-recap]', recap.join(' · '));

    var applyBtn = root.querySelector('[data-fh-sc-apply]');
    applyBtn.textContent = (root.dataset.applyTemplate || 'Größe [größe] auswählen').replace('[größe]', label);
    applyBtn.setAttribute('data-size', label);

    var inp = sizeInput(root, label);
    var soldOut = inp && inp.getAttribute('data-option-available') === 'false';
    var note = root.querySelector('[data-fh-sc-soldout]');
    if (note) note.hidden = !soldOut;
    applyBtn.hidden = !inp;

    try {
      localStorage.setItem(
        root.dataset.storageKey,
        JSON.stringify({
          size: label,
          breed: res.breed.n,
          ageKind: res.ageKind,
          months: res.months,
          weight: isFinite(res.weight) ? res.weight : null,
          ts: Date.now()
        })
      );
    } catch (e) {}

    paintSaved(root);
    show(root, 'result');
  }

  /* ----------------------------------------------------------- Scrollsperre */

  /*
   * showModal() macht den Hintergrund inert, sperrt das Scrollen aber NICHT -
   * die Produktseite lief unter dem offenen Rechner weiter (gemeldet
   * 31.08.2026 aus iOS Safari).
   *
   * overflow: hidden allein reicht auf iOS Safari nicht, Touch-Scroll geht
   * dort trotzdem durch. Verlaesslich ist nur, den Body aus dem Fluss zu
   * nehmen. Damit die Seite dabei nicht nach oben springt, wird die
   * Scrollposition als negatives top gehalten und beim Schliessen exakt
   * wiederhergestellt.
   */
  function lockScroll() {
    var b = document.body;
    if (b.style.position === 'fixed') return;
    var y = window.scrollY || window.pageYOffset || 0;
    b.dataset.fhScY = String(y);
    b.style.position = 'fixed';
    b.style.top = -y + 'px';
    b.style.insetInline = '0';
    b.style.width = '100%';
  }

  function unlockScroll() {
    var b = document.body;
    if (b.style.position !== 'fixed') return;
    var y = parseInt(b.dataset.fhScY || '0', 10) || 0;
    b.style.position = '';
    b.style.top = '';
    b.style.insetInline = '';
    b.style.width = '';
    delete b.dataset.fhScY;
    window.scrollTo(0, y);
  }

  /*
   * Entsperrt wird ueber das open-Attribut, NICHT ueber das close-Event.
   * Am 31.08.2026 gemessen: das close-Event kam nicht an - auch nicht bei
   * einem frisch erzeugten <dialog> und auch nicht mit Listener direkt am
   * Element. Ein MutationObserver auf open ist unabhaengig davon und deckt
   * jeden Schliessweg ab: Schliessen-Knopf, Klick auf den Hintergrund,
   * Uebernehmen der Groesse und die ESC-Taste, die der Browser selbst
   * behandelt. Seine Rueckrufe laufen als Mikrotask, also sofort.
   */
  function watchDialog(dlg) {
    if (dlg.fhWatched || !window.MutationObserver) return;
    dlg.fhWatched = true;
    new MutationObserver(function () {
      if (!dlg.open) unlockScroll();
    }).observe(dlg, { attributes: true, attributeFilter: ['open'] });
  }

  /* ---------------------------------------------------- Varianten-Selektor */

  function pickerOf(root) {
    var host = root.closest('.shopify-section') || document;
    return (
      host.querySelector('variant-picker[ref="mainVariantPicker"]') ||
      host.querySelector('variant-picker') ||
      document.querySelector('variant-picker[ref="mainVariantPicker"]') ||
      document.querySelector('variant-picker')
    );
  }

  function sizeInput(root, label) {
    var picker = pickerOf(root);
    if (!picker) return null;

    var wanted = String(label).trim().toLowerCase();
    var optName = (root.dataset.optionName || '').trim().toLowerCase();
    var inputs = picker.querySelectorAll('input[type="radio"]');
    var fallback = null;

    for (var i = 0; i < inputs.length; i++) {
      var inp = inputs[i];
      if ((inp.value || '').trim().toLowerCase() !== wanted) continue;
      var name = (inp.getAttribute('data-option-name') || '').trim().toLowerCase();
      if (optName && name === optName) return inp;
      if (!fallback) fallback = inp;
    }
    return fallback;
  }

  // checked + change, nie click(): ein click() ginge durch das
  // umschliessende <label> doppelt.
  function selectSize(root, label) {
    var target = sizeInput(root, label);
    if (!target || target.checked) return target;
    target.checked = true;
    target.dispatchEvent(new Event('change', { bubbles: true }));
    return target;
  }

  /* -------------------------------------------------------- Merken / Reset */

  function savedResult(root) {
    var saved = null;
    try {
      saved = JSON.parse(localStorage.getItem(root.dataset.storageKey) || 'null');
    } catch (e) {}
    if (!saved || !saved.size || !saved.ts || Date.now() - saved.ts >= TTL) return null;
    return saved;
  }

  function paintSaved(root) {
    var wrap = root.closest('.fh-sizecalc');
    if (!wrap) return;
    var sub = wrap.querySelector('[data-fh-sc-sub]');
    if (!sub) return;

    if (!sub.dataset.original) sub.dataset.original = sub.textContent;

    var saved = savedResult(root);
    sub.textContent = saved
      ? tpl(root, 'savedNote', 'Zuletzt berechnet: Größe [größe]', { '[größe]': saved.size })
      : sub.dataset.original;
  }

  function reset(root) {
    root.fhVals = {};
    root.fhNeedWeight = false;
    root.fhResult = null;

    var s = root.querySelector('[data-fh-sc-breed-search]');
    if (s) s.value = '';
    renderHits(root, []);

    var w = root.querySelector('[data-fh-sc-input="weight"]');
    if (w) w.value = '';

    var errs = root.querySelectorAll('[data-fh-sc-error]');
    for (var i = 0; i < errs.length; i++) errs[i].hidden = true;

    var chosen = root.querySelectorAll('.is-chosen');
    for (var j = 0; j < chosen.length; j++) chosen[j].classList.remove('is-chosen');

    var months = root.querySelector('[data-fh-sc-months]');
    if (months) months.hidden = true;

    paintChosenBreed(root);
  }

  function paintChosenBreed(root) {
    var el = root.querySelector('[data-fh-sc-chosen-breed]');
    if (!el) return;
    var b = (root.fhVals || {}).breed;
    el.textContent = b ? b.n : '';
    el.hidden = !b;
  }

  /* ------------------------------------------------------------- Auswahlen */

  function pickBreed(root, breed) {
    root.fhVals = root.fhVals || {};
    root.fhVals.breed = breed;
    paintChosenBreed(root);
    show(root, 'age');
  }

  function pickMix(root, cls) {
    var cfg = configOf(root);
    var range = cfg.mix[cls];
    if (!range) return;
    var names = cfg.mixNames || {};
    pickBreed(root, { n: names[cls] || cls, w: [num(range[0]), num(range[1])], mix: true });
  }

  // Nach dem Alter entscheidet sich, ob die Gewichtsfrage ueberhaupt kommt.
  function afterAge(root) {
    var probe = compute(root);
    root.fhNeedWeight = !!(probe.ok && !probe.certain);
    if (root.fhNeedWeight) show(root, 'weight');
    else finish(root);
  }

  function pickAge(root, kind, months) {
    root.fhVals = root.fhVals || {};
    root.fhVals.ageKind = kind;
    root.fhVals.months = kind === 'puppy' ? months : null;

    if (kind === 'puppy' && !isFinite(months)) {
      var box = root.querySelector('[data-fh-sc-months]');
      if (box) box.hidden = false;
      return;
    }
    afterAge(root);
  }

  function submitWeight(root, skip) {
    var step = root.querySelector('[data-fh-sc-step="weight"]');
    var input = step.querySelector('[data-fh-sc-input]');
    root.fhVals = root.fhVals || {};

    if (skip) {
      root.fhVals.weight = NaN;
      clearFail(step);
      finish(root);
      return;
    }

    var value = num(input.value);
    var lo = parseFloat(input.dataset.lo);
    var hi = parseFloat(input.dataset.hi);

    if (!isFinite(value)) {
      fail(step, root.dataset.errEmpty || 'Bitte trag einen Wert ein.');
      return;
    }
    if (value < lo || value > hi) {
      fail(step, root.dataset.errRange || 'Bitte prüf den Wert noch einmal – er wirkt unrealistisch.');
      return;
    }

    clearFail(step);
    root.fhVals.weight = value;
    finish(root);
  }

  function fail(step, message) {
    var box = step.querySelector('[data-fh-sc-error]');
    if (!box) return;
    box.textContent = message;
    box.hidden = false;
  }

  function clearFail(step) {
    if (!step) return;
    var box = step.querySelector('[data-fh-sc-error]');
    if (box) box.hidden = true;
  }

  function back(root) {
    var step = root.dataset.step;
    if (step === 'weight') show(root, 'age');
    else if (step === 'age') show(root, 'breed');
  }

  /* --------------------------------------------------------------- Events */

  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t || !t.closest) return;

    var opener = t.closest('[data-fh-sc-open]');
    if (opener) {
      var dlg = document.getElementById(opener.getAttribute('data-fh-sc-open'));
      if (!dlg) return;
      loadBreeds(dlg);
      reset(dlg);
      show(dlg, 'breed');
      if (typeof dlg.showModal === 'function') dlg.showModal();
      else dlg.setAttribute('open', '');
      watchDialog(dlg);
      lockScroll();
      return;
    }

    var root = t.closest('.fh-sizecalc__dialog');
    if (!root) return;

    if (t.closest('[data-fh-sc-close]')) {
      root.close();
      return;
    }

    var pick = t.closest('[data-fh-sc-pick]');
    if (pick) {
      var b = breedByName(root, pick.getAttribute('data-fh-sc-pick'));
      if (b) pickBreed(root, b);
      return;
    }

    var mixOpen = t.closest('[data-fh-sc-mix-open]');
    if (mixOpen) {
      show(root, 'mix');
      return;
    }

    var mix = t.closest('[data-fh-sc-mix]');
    if (mix) {
      pickMix(root, mix.getAttribute('data-fh-sc-mix'));
      return;
    }

    var age = t.closest('[data-fh-sc-age]');
    if (age) {
      var kind = age.getAttribute('data-fh-sc-age');
      var group = age.parentNode.querySelectorAll('[data-fh-sc-age]');
      for (var i = 0; i < group.length; i++) group[i].classList.remove('is-chosen');
      age.classList.add('is-chosen');
      pickAge(root, kind, NaN);
      return;
    }

    var month = t.closest('[data-fh-sc-month]');
    if (month) {
      pickAge(root, 'puppy', num(month.getAttribute('data-fh-sc-month')));
      return;
    }

    if (t.closest('[data-fh-sc-weight-next]')) {
      submitWeight(root, false);
      return;
    }
    if (t.closest('[data-fh-sc-weight-skip]')) {
      submitWeight(root, true);
      return;
    }
    if (t.closest('[data-fh-sc-back]')) {
      back(root);
      return;
    }
    if (t.closest('[data-fh-sc-restart]')) {
      reset(root);
      show(root, 'breed');
      return;
    }
    if (t.closest('[data-fh-sc-table]')) {
      root.dataset.tableFrom = root.dataset.step;
      show(root, 'table');
      return;
    }
    if (t.closest('[data-fh-sc-table-back]')) {
      show(root, root.dataset.tableFrom || 'breed');
      return;
    }

    var apply = t.closest('[data-fh-sc-apply]');
    if (apply) {
      var wanted = apply.getAttribute('data-size');
      var target = selectSize(root, wanted) || sizeInput(root, wanted);
      root.close();
      if (!target) return;
      var field = target.closest('fieldset') || target;
      try {
        field.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (e) {}
      field.classList.add('fh-sizecalc-flash');
      setTimeout(function () {
        field.classList.remove('fh-sizecalc-flash');
      }, 1500);
      return;
    }

    // Klick auf den Hintergrund schliesst.
    if (t === root) root.close();
  });

  document.addEventListener('input', function (event) {
    var t = event.target;
    if (!t || !t.closest) return;

    var s = t.closest('[data-fh-sc-breed-search]');
    if (s) {
      var root = s.closest('.fh-sizecalc__dialog');
      loadBreeds(root).then(function () {
        renderHits(root, search(root, s.value));
      });
      return;
    }
    var w = t.closest('[data-fh-sc-input]');
    if (w) clearFail(w.closest('[data-fh-sc-step]'));
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    var t = event.target;
    if (!t || !t.closest) return;

    var w = t.closest('[data-fh-sc-input="weight"]');
    if (w) {
      event.preventDefault();
      submitWeight(w.closest('.fh-sizecalc__dialog'), false);
      return;
    }
    // Enter im Suchfeld nimmt den ersten Treffer.
    var s = t.closest('[data-fh-sc-breed-search]');
    if (s) {
      event.preventDefault();
      var root = s.closest('.fh-sizecalc__dialog');
      var first = root.querySelector('[data-fh-sc-pick]');
      if (first) first.click();
    }
  });

  /* ----------------------------------------------------------- Standardgroesse */

  /*
   * Shopify waehlt immer die erste verfuegbare Variante, also S. Ueber die
   * Variantenreihenfolge laesst sich das nicht verschieben: Shopify leitet
   * daraus sofort die Reihenfolge der Optionswerte ab, M nach vorn zu
   * ziehen haette die Groessen-Buttons zu "M S L XL" gemacht. Deshalb hier.
   *
   * Ein gespeichertes Rechner-Ergebnis (30 Tage) schlaegt die Standardgroesse.
   */
  function applyDefaultSize(root) {
    if (window.fhSizeCalcDefaultDone) return;
    window.fhSizeCalcDefaultDone = true;

    // Wer ueber einen Variantenlink kommt, hat seine Groesse schon gewaehlt.
    try {
      if (new URLSearchParams(window.location.search).has('variant')) return;
    } catch (e) {}

    var saved = savedResult(root);
    var wanted = saved ? saved.size : (root.dataset.defaultSize || '').trim();
    if (!wanted) return;

    var target = sizeInput(root, wanted);
    if (!target || target.checked) return;
    if (target.getAttribute('data-option-available') === 'false') return;

    selectSize(root, wanted);
  }

  function initDefault() {
    var root = document.querySelector('[data-fh-sc-root]');
    if (!root) return;

    var fired = false;
    var fire = function () {
      if (fired) return;
      fired = true;
      applyDefaultSize(root);
    };

    // Horizons VariantPicker haengt seinen change-Listener erst in
    // connectedCallback ein. Wird vorher gefeuert, springt der Radio um,
    // ohne dass Preis und Warenkorb-Button nachziehen.
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('variant-picker').then(function () {
        requestAnimationFrame(fire);
      });
    }
    // Sicherheitsnetz, falls das Custom Element nie registriert wird.
    setTimeout(fire, 1500);
  }

  function init() {
    var roots = document.querySelectorAll('[data-fh-sc-root]');
    for (var i = 0; i < roots.length; i++) paintSaved(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      initDefault();
    });
  } else {
    init();
    initDefault();
  }
  document.addEventListener('shopify:section:load', init);
})();
